import { FaArrowRight, FaChartLine, FaHandshake, FaHouseUser, FaMapMarkerAlt, FaToolbox, FaTools, FaUser } from "react-icons/fa";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import abtimg from "../../Images/Handshack.webp";

export default function WhyChooseUs() {
  const navigate = useNavigate();

  return (
    <div className="w-full py-20 px-6 md:px-12 bg-gradient-to-b from-white to-blue-50 relative overflow-hidden">
      {/* Decorative Elements */}
      {/* <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-r from-blue-600 to-blue-800" /> */}
      <div className="absolute bottom-20 -right-40 w-96 h-96 bg-blue-100 rounded-full opacity-20" />

      {/* Hero Header */}
      <motion.div
        className="text-center max-w-4xl mx-auto mb-16 relative z-10"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="inline-flex items-center gap-2 mb-4 text-blue-600 font-medium">
          <FaHandshake className="text-xl" />
          <span>Trusted Since 2018</span>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">
          JANATHA Automobiles pvt ltd
        </h1>
        <p className="mt-4 text-lg text-gray-600 font-medium max-w-2xl mx-auto">
          Building Trust. Driving Progress. Delivering Excellence.
        </p>
      </motion.div>

      {/* About Section */}
      <div className="grid md:grid-cols-2 items-center gap-16 max-w-7xl mx-auto relative z-10">
        {/* Text Section */}
        <motion.div
          className="space-y-8"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
        >
          {/* <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full mb-4">
            <span className="font-medium">About Our Legacy</span>
          </div> */}

          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white">
                  <FaTools className="text-xl" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">About JAPL</h3>
                <p className="text-gray-600">
                  Established in December 2018, Janatha Automobiles Pvt Ltd
                  is the flagship company of Janatha Group and an authorized 3S dealership, involved in
                  Sales, Service, Spare Parts for TATA Motors commercial vehicles.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white">
                  <FaChartLine className="text-xl" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Growth & Innovation</h3>
                <p className="text-gray-600">
                  Headquartered in Hospet, Karnataka, we’ve rapidly become a trusted
                  name across North Karnataka. With branches in Danapur, Gangavathi,
                  Kurekuppa, Raichur, and Bellary, we offer reliable
                  service tailored to your needs.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white">
                  <FaUser className="text-xl" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Customer First</h3>
                <p className="text-gray-600">
                  Our customer-first approach and strategic presence drive JAPL's
                  growth in the commercial vehicle sector—making us your dependable
                  partner on every journey.
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-8">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-50">
              <div className="text-3xl font-bold text-blue-600">5+</div>
              <div className="text-gray-600">Branches</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-50">
              <div className="text-3xl font-bold text-blue-600">3500+</div>
              <div className="text-gray-600">Vehicles Delivered</div>
            </div>
          </div>
        </motion.div>

        {/* Image Section */}
        <motion.div
          className="relative group"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-800 opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300" />
          <img
            src={abtimg}
            alt="About Us"
            className="rounded-2xl shadow-2xl object-cover w-full h-[500px] transform group-hover:scale-[1.02] transition-transform duration-300"
          />
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2">
            <span className="text-blue-600 font-medium">Trusted Partnership</span>
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <FaHandshake className="text-blue-600" />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Mission & Vision Section */}
      <div className="mt-24 grid md:grid-cols-2 gap-8 max-w-7xl mx-auto relative z-10">
        <motion.div
          className="bg-white rounded-2xl p-8 shadow-xl border border-blue-50 relative overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="absolute top-0 right-0 w-24 h-24 bg-blue-100 opacity-20 rounded-bl-full" />
          <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white">
              <FaChartLine />
            </div>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">
              Our Mission
            </span>
          </h3>
          <p className="text-gray-700 text-lg leading-relaxed">
          At JAPL, we are committed to exceptional customer service and technical
            excellence. With integrity, transparency, and a passion for quality,
            we strive to build lasting relationships and drive customer success.
          </p>
        </motion.div>

        <motion.div
          className="bg-white rounded-2xl p-8 shadow-xl border border-blue-50 relative overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-blue-100 opacity-20 rounded-tr-full" />
          <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white">
              <FaHandshake />
            </div>
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">
              Our Vision
            </span>
          </h3>
          <p className="text-gray-700 text-lg leading-relaxed">
          To become a trusted and customer centric, Tata Motors dealership - setting benchmarks in service excellence, client satisfaction, and operational innovation.
          </p>
        </motion.div>
      </div>

      {/* Timeline Section */}
      {/* <div className="mt-24 max-w-7xl mx-auto relative z-10">
        <h3 className="text-2xl font-bold text-center mb-12">Our Journey</h3>
        <div className="relative pl-8 border-l-2 border-blue-100 ml-4">
          <div className="absolute w-4 h-4 bg-blue-600 rounded-full -left-[9px] top-0" />
          <div className="mb-12">
            <div className="text-blue-600 font-medium">2018</div>
            <div className="text-lg font-semibold mt-2">Foundation Established</div>
            <p className="text-gray-600">Started as authorized Tata Motors 3S dealership</p>
          </div>
          
          <div className="absolute w-4 h-4 bg-blue-600 rounded-full -left-[9px] top-1/3" />
          <div className="mb-12">
            <div className="text-blue-600 font-medium">2020</div>
            <div className="text-lg font-semibold mt-2">Regional Expansion</div>
            <p className="text-gray-600">Opened 3 new branches in North Karnataka</p>
          </div>

          <div className="absolute w-4 h-4 bg-blue-600 rounded-full -left-[9px] top-2/3" />
          <div className="mb-12">
            <div className="text-blue-600 font-medium">2023</div>
            <div className="text-lg font-semibold mt-2">Milestone Achievement</div>
            <p className="text-gray-600">Crossed 5000+ vehicles delivered</p>
          </div>
        </div>
      </div> */}
    </div>
  );
}